<template>
  <div
    id="form-search-popover"
    class="container-app-search">

    <div
      :class="{ 'studio-page-header-long' : !is_sidebar_minimized }"
      class="studio-page-header">
      <h4 class="title-tab-experience-manager">DATA CONNECTIVITY</h4>
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            class="btn grey btn-import-form m__r--5"
            @click="openModalDetail(null, 'create')">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
          <b-form
            inline
            @keypress.13.prevent="$refs.dataConnectivityTableComponent.setFilter(filter_data)">
            <j-select
              v-model="select_type"
              :options="options_search"
              :error-required="false"
              placeholder="Filter By"
              class="m__r--5"/>
            <span
              v-if="select_type === 'created_at'"
              class="date-filter m__r--5">
              <j-datepicker
                v-model="filter_data_start_date"
                :error-required="false"
                placeholder="Start Date"
                format="MMM dd, yyyy"
                class="m__r--5"/>
              <j-datepicker
                v-model="filter_data_end_date"
                :disabled-dates="disableDates(filter_data_start_date)"
                :error-required="false"
                placeholder="End Date"
                format="MMM dd, yyyy"/>
            </span>
            <b-form-input
              v-else
              ref="filterInput"
              v-model="filter_data"
              placeholder="Search"
              style="width: 250px; height: 35px"/>
          </b-form>
        </b-form>
      </div>
    </div>

    <div class="studio-page-content">
      <v-server-table
        v-show="load_first"
        ref="dataConnectivityTableComponent"
        :columns="columns"
        :options="table_options"
        class="jTable"
        @loading="loading"
        @loaded="loaded">

        <div
          slot="id"
          slot-scope="props"
          @click="openModalDetail(props.row, 'detail')">
          {{ props.row.id }}
        </div>
        <div
          slot="connection_name"
          slot-scope="props"
          @click="openModalDetail(props.row, 'detail')">
          {{ props.row.connection_name }}
        </div>
        <div
          slot="database_driver"
          slot-scope="props"
          @click="openModalDetail(props.row, 'detail')">
          {{ props.row.database_driver }}
        </div>
        <div
          slot="host"
          slot-scope="props"
          @click="openModalDetail(props.row, 'detail')">
          {{ props.row.host }}
        </div>
        <div
          slot="database"
          slot-scope="props"
          @click="openModalDetail(props.row, 'detail')">
          {{ props.row.database }}
        </div>
        <div
          slot="created_at"
          slot-scope="props"
          @click="openModalDetail(props.row, 'detail')">
          {{ convertDate(props.row.created_at) }}
        </div>


      </v-server-table>
      <jLoadingTable v-if="!load_first"/>
    </div>

    <b-modal
      ref="modalDetailDataConnectivity"
      class="mod-form modal-form-ui"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <div>
        <div class="modal-title-jdc"> {{ mode === 'edit' ? 'Detail' : 'Add' }} Connection </div>
        <div class="sub-container">
          <div
            class="circle-border">
            1
          </div>

          <b-row>
            <b-col cols="12">
              <label> Database Driver </label>
              <div
                class="d-flex flex-wrap align-items-center">
                <div
                  :class="{
                    'driver-img-selected':dataConnectivity.database_driver === 'mysql',
                    'error-border': $v.dataConnectivity.database_driver.$error
                  }"
                  class="driver_options"
                  @click="changeDatabaseDriver('mysql')">
                  <img
                    class="driver-img"
                    src="@/assets/logo/db-driver/mysql.png"
                    alt="mysql">
                </div>
                <div
                  :class="{
                    'driver-img-selected':dataConnectivity.database_driver === 'postgres',
                    'error-border': $v.dataConnectivity.database_driver.$error
                  }"
                  class="driver_options"
                  @click="changeDatabaseDriver('postgres')">
                  <img
                    class="driver-img"
                    src="@/assets/logo/db-driver/postgress.png"
                    alt="postgress">
                </div>
                <div
                  :class="{
                    'driver-img-selected':dataConnectivity.database_driver === 'sqlserver',
                    'error-border': $v.dataConnectivity.database_driver.$error
                  }"
                  class="driver_options"
                  @click="changeDatabaseDriver('sqlserver')">
                  <img
                    class="driver-img"
                    src="@/assets/logo/db-driver/sqlserver.png"
                    alt="sqlserver">
                </div>
                <div
                  :class="{
                    'driver-img-selected':dataConnectivity.database_driver === 'graph',
                    'error-border': $v.dataConnectivity.database_driver.$error
                  }"
                  class="driver_options"
                  @click="changeDatabaseDriver('graph')">
                  <img
                    class="driver-img-graph"
                    src="@/assets/logo/db-driver/graph.svg"
                    alt="graph">
                </div>
                <div
                  :class="{
                    'driver-img-selected':dataConnectivity.database_driver === 'clickhouse',
                    'error-border': $v.dataConnectivity.database_driver.$error
                  }"
                  class="driver_options"
                  @click="changeDatabaseDriver('clickhouse')">
                  <img
                    class="driver-img"
                    src="@/assets/logo/db-driver/clickhouse.svg"
                    alt="clickhouse">
                </div>
                <div
                  :class="{
                    'driver-img-selected':dataConnectivity.database_driver === 'oracle',
                    'error-border': $v.dataConnectivity.database_driver.$error
                  }"
                  class="driver_options"
                  @click="changeDatabaseDriver('oracle')">
                  <img
                    class="driver-img"
                    src="@/assets/logo/db-driver/oracle.png"
                    alt="oracle">
                </div>
                <div
                  :class="{
                    'driver-img-selected':dataConnectivity.database_driver === 'db2',
                    'error-border': $v.dataConnectivity.database_driver.$error
                  }"
                  class="driver_options driver-img-disabled">
                  <img
                    class="driver-img"
                    src="@/assets/logo/db-driver/db2.png"
                    alt="db2">
                </div>
              </div>

            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div>
                <b-form-group :class="{'error-input' : $v.dataConnectivity.connection_name.$error}">
                  <label for="name"> Connection Name </label>
                  <j-input
                    v-model="dataConnectivity.connection_name"
                    :error-required="$v.dataConnectivity.connection_name.$error"
                    :disabled="mode == 'edit'"
                    :error-message="
                    error_minimum_connection_name ? 'Minimum 8 Character' : 'Field is required'"
                    placeholder="Enter connection name here"/>
                </b-form-group>
                <b-form-group
                  v-if="dataConnectivity.database_driver !== 'graph'"
                  :class="{'error-input' : $v.dataConnectivity.connection_method.$error}"
                  class="m__t--7">
                  <label for="name"> Connection Method </label>
                  <j-single-select
                    v-model="dataConnectivity.connection_method"
                    :options="listConnectionTypeTable"
                    :disabled="mode == 'edit' ||
                      dataConnectivity.database_driver === 'clickhouse' ||
                    dataConnectivity.database_driver === 'oracle'"
                    :error-required="$v.dataConnectivity.connection_method.$error"
                    :placeholder="'Select connection method here'"
                    label="text"/>
                </b-form-group>
                <b-form-group
                  v-if="dataConnectivity.database_driver === 'oracle'"
                  :class="{'error-input' : $v.dataConnectivity.service_name.$error}">
                  <label for="name"> Service Name </label>
                  <j-input
                    v-model="dataConnectivity.service_name"
                    :error-required="$v.dataConnectivity.service_name.$error"
                    :disabled="mode == 'edit'"
                    placeholder="Enter service name here"/>
                </b-form-group>
                <b-form-group
                  v-if="dataConnectivity.database_driver === 'postgres'"
                  :class="{'error-input' : $v.dataConnectivity.database.$error}">
                  <label for="name"> Database </label>
                  <j-input
                    v-model="dataConnectivity.database"
                    :disabled="mode == 'edit'"
                    :error-required="$v.dataConnectivity.database.$error"
                    placeholder="Enter database"/>
                </b-form-group>
                <b-form-group
                  v-if="dataConnectivity.database_driver === 'postgres'"
                  :class="{'error-input' : $v.dataConnectivity.schema.$error}">
                  <label for="name"> Schema </label>
                  <j-input
                    v-model="dataConnectivity.schema"
                    :disabled="mode == 'edit'"
                    :error-required="$v.dataConnectivity.schema.$error"
                    placeholder="Enter schema path"/>
                </b-form-group>
              </div>
            </b-col>
          </b-row>
          <label
            v-if="dataConnectivity.connection_method === 'tcp-ssh'"
            class="m__t--20">SSH Server</label>
          <b-row v-if="dataConnectivity.connection_method === 'tcp-ssh'">
            <b-col cols="8">
              <div>
                <b-form-group :class="{'error-input' : $v.dataConnectivity.ssh_host.$error}">
                  <label for="name"> Host </label>
                  <j-input
                    v-model="dataConnectivity.ssh_host"
                    :disabled="mode == 'edit'"
                    :error-required="$v.dataConnectivity.ssh_host.$error"
                    placeholder="Enter host here"/>
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="4">
              <div>
                <b-form-group :class="{'error-input' : $v.dataConnectivity.ssh_port.$error}">
                  <label for="name"> Port </label>
                  <j-input
                    v-model="dataConnectivity.ssh_port"
                    :disabled="mode == 'edit'"
                    :error-required="$v.dataConnectivity.ssh_port.$error"
                    placeholder="22"/>
                </b-form-group>
              </div>
            </b-col>
          </b-row>
          <b-row
            v-if="dataConnectivity.connection_method === 'tcp-ssh'"
            class="m__t--7">
            <b-col cols="6">
              <div>
                <b-form-group :class="{'error-input' : $v.dataConnectivity.ssh_username.$error}">
                  <label for="name"> Username </label>
                  <j-input
                    v-model="dataConnectivity.ssh_username"
                    :disabled="mode == 'edit'"
                    :error-required="$v.dataConnectivity.ssh_username.$error"
                    placeholder="Enter username here"/>
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="6">
              <div>
                <b-form-group :class="{'error-input' : $v.dataConnectivity.ssh_password.$error}">
                  <label for="name"> Password </label>
                  <j-input
                    id="passord"
                    v-model="dataConnectivity.ssh_password"
                    :disabled="mode == 'edit'"
                    :error-required="$v.dataConnectivity.ssh_password.$error"
                    type="password"
                    placeholder="*************"/>
                </b-form-group>
              </div>
            </b-col>
          </b-row>
          <label class="m__t--20">Database Server</label>
          <b-row>
            <b-col cols="8">
              <div>
                <b-form-group :class="{'error-input' : $v.dataConnectivity.host.$error}">
                  <label for="name"> Host </label>
                  <j-input
                    v-model="dataConnectivity.host"
                    :disabled="mode == 'edit'"
                    :error-required="$v.dataConnectivity.host.$error"
                    placeholder="Enter host here"/>
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="4">
              <div>
                <b-form-group :class="{'error-input' : $v.dataConnectivity.port.$error}">
                  <label for="name"> Port </label>
                  <j-input
                    v-model="dataConnectivity.port"
                    :disabled="mode == 'edit'"
                    :error-required="$v.dataConnectivity.port.$error"
                    placeholder="Enter port here"/>
                </b-form-group>
              </div>
            </b-col>
          </b-row>
          <b-row class="m__t--7">
            <b-col cols="6">
              <div>
                <b-form-group :class="{'error-input' : $v.dataConnectivity.username.$error}">
                  <label for="name"> Username </label>
                  <j-input
                    v-model="dataConnectivity.username"
                    :disabled="mode == 'edit'"
                    :error-required="$v.dataConnectivity.username.$error"
                    placeholder="Enter username here"/>
                </b-form-group>
              </div>
            </b-col>
            <b-col cols="6">
              <div>
                <b-form-group :class="{'error-input' : $v.dataConnectivity.password.$error}">
                  <label for="name"> Password </label>
                  <j-input
                    id="passord"
                    v-model="dataConnectivity.password"
                    :disabled="mode == 'edit'"
                    :error-required="$v.dataConnectivity.password.$error"
                    type="password"
                    placeholder="*************"/>
                </b-form-group>
              </div>
            </b-col>
          </b-row>
          <b-row
            v-show="mode == 'create'"
            class="m__t--10">
            <b-col>
              <div>
                <div class="float-right">
                  <b-button
                    id="btn-verify"
                    variant="outline-primary"
                    class="btn"
                    @click="verifyDataConnection">
                    Verify
                  </b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </div>
        <div
          v-if= "listDatabaseOptions.length != 0 &&
            dataConnectivity.database_driver !== 'graph' &&
          dataConnectivity.database_driver !== 'oracle'"
          class="sub-container">
          <div
            class="circle-border">
            2
          </div>
          <h4>Default Scheme</h4>
          <b-row>
            <b-col cols="12">
              <div>
                <b-form-group :class="{'error-input' : $v.dataConnectivity.database.$error}">
                  <label for="name"> Database </label>
                  <j-single-select
                    v-model="dataConnectivity.database"
                    :options="listDatabaseOptions"
                    :disabled="mode == 'edit' ||
                    (mode === 'create' && dataConnectivity.database_driver === 'postgres')"
                    :error-required="$v.dataConnectivity.database.$error"
                    :placeholder="'Select database here'"
                    label="text"/>
                </b-form-group>
              </div>
            </b-col>
          </b-row>

        </div>
        <div class="m__t--10">
          <b-button
            v-if ="mode == 'edit'"
            class="btn red"
            @click="deleteDataConnectiion(dataConnectivity.id)">
            Delete
          </b-button>
          <span class="float-right">
            <b-button
              class="btn btn-jdc white"
              @click="closeModalDetail">
              Close
            </b-button>
            <b-button
              v-if="mode != 'edit'"
              class="btn btn-jdc blue m__l--5"
              @click="setDataConnection">
              Save
            </b-button>
          </span>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';
import jApiDataConnectivity from '@/services/jApiDataConnectivity';
import jwtDecode from 'jwt-decode';
import { mapActions, mapState } from 'vuex';
import { required, requiredIf, minLength } from 'vuelidate/lib/validators';

export default {
  components: {
    jLoadingTable,
  },
  data() {
    return {
      listConnectionTypeTable: [
        { id: 'tcp', text: 'Standart TCP/IP', value: 'tcp' },
        { id: 'tcp-ssh', text: 'Standart TCP/IP over SSH', value: 'tcp-ssh' },
      ],
      listDatabaseOptions: [],
      popoverSearchShow: false,
      JDataConnectivityDetailearchShow: false,
      error_minimum_connection_name: false,
      mode: '',
      load_first: false,
      filter_data: '',
      filter_data_start_date: null,
      filter_data_end_date: null,
      select_type: 'connection_name',
      isDetailOpen: false,
      data_table: [],
      dataConnectivity: {
        connection_name: '',
      },
      session: jwtDecode(JSON.parse(localStorage.getItem('Token')).value),
      options_search: [
        {
          text: 'ID',
          value: 'id',
        },
        {
          text: 'Name',
          value: 'connection_name',
        },
        {
          text: 'Database Driver',
          value: 'database_driver',
        },
        {
          text: 'Host',
          value: 'host',
        },
        {
          text: 'Default Scehme',
          value: 'database',
        },
        {
          text: 'Created Date',
          value: 'created_at',
        },
      ],
      columns: ['id', 'connection_name', 'database_driver', 'host', 'database', 'created_at'],
      table_options: {
        headings: {
          id: 'ID',
          connection_name: 'NAME',
          database_driver: 'DATABASE DRIVER',
          host: 'HOST NAME',
          database: 'DEFAULT SCHEME',
          created_at: 'CREATED_DATE',

        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        sortable: ['id', 'connection_name', 'database_driver', 'host', 'database', 'created_at'],
        debounce: 5,
        filterable: true,
        perPage: 10,
        perPageValues: [5, 10, 20, 50, 100],
        requestAdapter(data) {
          let sortData = {};
          switch (data.orderBy) {
            case 'connection_name':
              sortData = { connection_name: data.ascending ? 1 : -1 };
              break;
            case 'id':
              sortData = { id: data.ascending ? 1 : -1 };
              break;
            case 'host':
              sortData = { host: data.ascending ? 1 : -1 };
              break;
            case 'database_driver':
              sortData = { database_driver: data.ascending ? 1 : -1 };
              break;
            case 'created_at':
              sortData = { created_at: data.ascending ? 1 : -1 };
              break;
            case 'database':
              sortData = { database: data.ascending ? 1 : -1 };
              break;
            default:
              sortData = { created_at: -1 };
          }
          return {
            pagination: {
              limit: data.limit,
              page: data.page,
              sort: sortData,
            },
          };
        },
        requestFunction(data) {
          const list = jApiDataConnectivity.getListDataConnectivity(data.pagination);
          return list.catch((e) => {
            this.$store.commit('jStoreNotificationScreen/toggleProblem', e.message);
          });
        },
        responseAdapter({ data }) {
          return {
            data: data.data ? data.data : [],
            count: data.length ? data.length : 0,
          };
        },
      },
    };
  },
  computed: {
    ...mapState('jStoreSetting', ['is_sidebar_minimized']),
  },
  watch: {
    // eslint-disable-next-line
    'dataConnectivity.connection_name': function (val){
      const regexSymbol = /[^\w\s]/g;
      if (val) {
        setTimeout(() => {
          this.dataConnectivity.connection_name =
              val.toLowerCase()
                .replace(regexSymbol, '')
                .replace(' ', '_');
        }, 1);
      }
    },
    filter_data(val) {
      if (val === '') {
        this.$refs.automationTableComponent.setFilter('');
      }
    },
    filter_data_start_date(val) {
      if (val && this.filter_data_end_date) {
        this.filter(this.filter_data);
      }
    },

    filter_data_end_date(val) {
      if (val && this.filter_data_start_date) {
        this.filter(this.filter_data);
      }
    },
  },
  mounted() {
    if (this.select_type !== 'created_at') {
      this.$refs.filterInput.focus();
    }
  },
  methods: {
    ...mapActions('jStoreDataConnectivity', ['setDataConnectivity', 'deleteDataConnectivity', 'verifyDataConnectivity']),

    convertDate(milisecond) {
      return new Date(milisecond - (new Date(milisecond).getTimezoneOffset() * 60000)).toISOString().replace(/T/, ' ').replace(/[.][\d]{3}Z/, '');
    },
    loading(val) {
      const a = val;
      let dataFilter = {
        company_id: this.session.user.company_id,
      };

      switch (this.select_type) {
        case 'database_driver':
          dataFilter = {
            database_driver: this.filter_data,
          };
          break;
        case 'id':
          dataFilter = {
            id: this.filter_data,
          };
          break;
        case 'connection_name':
          dataFilter = {
            connection_name: this.filter_data,
          };
          break;
        case 'host':
          dataFilter = {
            host: this.filter_data,
          };
          break;
        case 'database':
          dataFilter = {
            database: this.filter_data,
          };
          break;
        default:
          dataFilter = {
            company_id: this.session.user.company_id,
          }; break;
      }

      if (this.filter_data === '') {
        dataFilter = {
          company_id: this.session.user.company_id,
        };
      }
      if (this.select_type === 'created_at') {
        if (this.filter_data_start_date === null || this.filter_data_end_date === null) {
          dataFilter = {
            company_id: this.session.user.company_id,
          };
          return;
        }
        const filterDate = {};
        const start = new Date(this.filter_data_start_date);
        start.setHours(0, 0, 0);
        const end = new Date(this.filter_data_end_date);
        end.setHours(23, 59, 59);
        filterDate.$between = [
          start.getTime(),
          end.getTime(),
        ];
        dataFilter = {
          created_at: filterDate,
        };
      }
      a.pagination.filter = JSON.stringify(dataFilter);
      if (this.load_first) {
        this.$refs.dataConnectivityTableComponent.loading = true;
        this.$refs.dataConnectivityTableComponent.data = [];
      }
    },
    loaded(data) {
      this.data_table = data.data;
      if (!this.load_first) {
        this.load_first = !this.load_first;
      }
    },
    filter(val) {
      this.$refs.dataConnectivityTableComponent.setFilter(val);
    },
    openModalDetail(data, action) {
      this.isDetailOpen = true;
      switch (action) {
        case 'detail':
          this.dataConnectivity = Object.assign({}, data);
          this.listDatabaseOptions = [{
            id: this.dataConnectivity.database,
            text: this.dataConnectivity.database,
            value: this.dataConnectivity.database,
          }];
          this.mode = 'edit';
          break;
        default:
          this.dataConnectivity = {
            id: '',
            database_driver: '',
            connection_name: '',
            connection_method: null,
            schema: '',
            host: '',
            port: '',
            username: '',
            password: '',
            ssh_host: '',
            ssh_port: '',
            ssh_username: '',
            ssh_password: '',
            database: null,
            service_name: '',
          };
          this.mode = 'create';
      }
      this.error_minimum_connection_name = false;
      this.$refs.modalDetailDataConnectivity.show();
    },
    closeModalDetail() {
      this.$refs.modalDetailDataConnectivity.hide();
      this.$v.dataConnectivity.$reset();
      this.dataConnectivity = { };
      this.listDatabaseOptions = [];
      this.isDetailOpen = false;
      this.error_minimum_connection_name = false;
    },
    changeDatabaseDriver(val) {
      if (this.mode !== 'edit') {
        this.dataConnectivity.database_driver = val;
      }
      if (val === 'clickhouse' || val === 'oracle') {
        this.dataConnectivity.connection_method = 'tcp';
      } else {
        this.dataConnectivity.connection_method = null;
      }
    },
    validateData() {
      this.$v.dataConnectivity.$touch();
      return this.$v.dataConnectivity.$error;
    },
    setDataConnection() {
      if (this.validateSet()) {
        return;
      }
      if (this.dataConnectivity.database_driver === 'graph') {
        this.dataConnectivity.connection_method = 'tcp';
        this.dataConnectivity.database = 'graphdb';
      }
      if (this.dataConnectivity.database_driver === 'oracle') {
        this.dataConnectivity.connection_method = 'tcp';
        this.dataConnectivity.database = 'oracledb';
      }
      this.dataConnectivity.connection_name = this.dataConnectivity.connection_name.replace(/[ ]/g, '_');
      this.setDataConnectivity(this.dataConnectivity).then(() => {
        this.closeModalDetail();
        this.refreshTable();
      });
    },
    deleteDataConnectiion(dataId) {
      const text = `Are you sure to delete ${this.dataConnectivity.connection_name}?`;

      this.$swal({
        title: 'Delete',
        text,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Delete',
        confirmButtonColor: '#D2232A',
        cancelButtonColor: '#D2232A',
        titleColor: '#D2232A',
      }).then(async (result) => {
        if (result.value) {
          const param = {
            id: dataId,
          };
          this.deleteDataConnectivity(param).then(() => {
            this.closeModalDetail();
            this.refreshTable();
          });
        }
      });
    },
    verifyDataConnection() {
      if (this.validateVerify()) {
        return;
      }
      const req = Object.assign({}, this.dataConnectivity);
      if (this.dataConnectivity.database_driver !== 'postgres') {
        req.database = '';
      }
      if (this.dataConnectivity.database_driver === 'graph') req.connection_method = 'tcp';
      this.verifyDataConnectivity(req).then((data) => {
        if (data.error) {
          this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'Failed to connect', { root: true });
          return;
        }
        const options = [];
        if (data.data) data.data.forEach((val) => { options.push({ id: val, text: val }); });
        this.listDatabaseOptions = options;
        this.error_minimum_connection_name = false;
        this.$store.dispatch('jStoreNotificationScreen/toggleSuccess', data.message, { root: true });
      }).catch(() => {
        this.$store.dispatch('jStoreNotificationScreen/toggleProblem', 'Failed to connect', { root: true });
      });
    },
    refreshTable() {
      this.$refs.dataConnectivityTableComponent.refresh();
    },
    validateSet() {
      this.$v.dataConnectivity.$touch();
      let errorLengthValidation = false;
      if (this.dataConnectivity.connection_name.length < 8) {
        this.error_minimum_connection_name = true;
        errorLengthValidation = true;
      }
      return this.$v.dataConnectivity.$error || errorLengthValidation;
    },
    validateVerify() {
      this.$v.dataConnectivity.database_driver.$touch();
      this.$v.dataConnectivity.host.$touch();
      this.$v.dataConnectivity.port.$touch();
      this.$v.dataConnectivity.username.$touch();
      this.$v.dataConnectivity.password.$touch();
      this.$v.dataConnectivity.connection_method.$touch();
      this.$v.dataConnectivity.schema.$touch();

      let sshConnectivity = false;
      if (this.dataConnectivity.connection_method === 'tcp-ssh') {
        this.$v.dataConnectivity.ssh_host.$touch();
        this.$v.dataConnectivity.ssh_port.$touch();
        this.$v.dataConnectivity.ssh_username.$touch();
        this.$v.dataConnectivity.ssh_password.$touch();

        sshConnectivity = this.$v.dataConnectivity.ssh_host.$error ||
                this.$v.dataConnectivity.ssh_port.$error ||
                this.$v.dataConnectivity.ssh_username.$error ||
                this.$v.dataConnectivity.ssh_password.$error;
      }

      if (this.dataConnectivity.database_driver === 'postgres') {
        this.$v.dataConnectivity.database.$touch();
      }

      if (this.dataConnectivity.database_driver === 'oracle') {
        this.$v.dataConnectivity.service_name.$touch();
      }

      return this.$v.dataConnectivity.database_driver.$error ||
                this.$v.dataConnectivity.host.$error ||
                this.$v.dataConnectivity.port.$error ||
                this.$v.dataConnectivity.username.$error ||
                this.$v.dataConnectivity.password.$error ||
                this.$v.dataConnectivity.connection_method.$error ||
                this.$v.dataConnectivity.schema.$error ||
                this.$v.dataConnectivity.database.$error ||
                sshConnectivity;
    },
    disableDates(date) {
      if (date) {
        return {
          to: new Date(date - 8640000),
        };
      }
      return {};
    },
    clearErrorMinimumLength() {
      this.error_minimum_connection_name = false;
    },

  },
  validations() {
    return {
      dataConnectivity: {
        database_driver: { required },
        host: { required },
        port: { required },
        username: { required },
        password: { required: requiredIf(() => this.mode === 'create') },
        ssh_host: { required: requiredIf(() => this.dataConnectivity.connection_method === 'tcp-ssh') },
        ssh_port: { required: requiredIf(() => this.dataConnectivity.connection_method === 'tcp-ssh') },
        ssh_username: { required: requiredIf(() => this.dataConnectivity.connection_method === 'tcp-ssh') },
        ssh_password: { required: requiredIf(() => this.mode === 'create' && this.dataConnectivity.connection_method === 'tcp-ssh') },
        connection_method: { required: requiredIf(() => this.dataConnectivity.database_driver !== 'graph' && this.dataConnectivity.database_driver !== 'oracle') },
        schema: { required: requiredIf(() => this.dataConnectivity.database_driver === 'postgres') },
        database: { required: requiredIf(() => this.dataConnectivity.database_driver !== 'graph' && this.dataConnectivity.database_driver !== 'oracle') },
        connection_name: { required, minLength: minLength(8) },
        service_name: { required: requiredIf(() => this.dataConnectivity.database_driver === 'oracle') },
      },
    };
  },
};
</script>
<style lang="scss">
#btn-verify{
  background: #FFFFFF;
  border: 1px solid #E3E3E3;
  border-radius: 4px;
  width: 165px;

  font-family: 'Poppins-Medium' !important;
  font-size: 14px;
  line-height: 17px;
  color: #1A85E4;
}
.btn-jdc {
  font-family: 'Poppins-Medium' !important;
}
.driver_options{
    background: #FFFFFF;
    border: 1px solid #E7E7E7;
    box-sizing: border-box;
    border-radius: 4px;
    padding:10px;
    width: 100px;
    height:75px;
    margin: 0px 5px 5px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
}
.driver-img-graph{
    height: auto;
    width: 43px;
}
.driver-img{
    height: auto;
    width: 53px;
}
.driver-img-selected{
    background: #EFF8FF;
    border: 1px solid #1A85E4;
}
.driver-img-disabled{
    background: #EFF8FF;
    opacity: 0.2;
    border: 1px solid #C7C6C6;
}
.circle-border{
    background-color: #ffffff;
    width: 25px;
    text-align: center;
    border-radius: 15px;
    border: 1px solid rgba(0, 0, 0, 0.125);
    margin: -28px 0 0 42%;
    z-index: 100;
    position: absolute;
}
.sub-container{
    border:1px solid rgba(0, 0, 0, 0.125);
    border-radius: 4px;
    padding: 15px;
    margin-top: 30px;
}
.error-border{
  border: 1px solid red;
}
.date-filter{
  display : flex;
}
.jTable .select-input {
  height: 35px !important;
  font-family: 'Poppins-Regular' !important;
  font-size: 14px !important;
}
.modal-title-jdc {
  font-family: 'Poppins-SemiBold';
  font-style: normal;
  font-size: 18px;
  line-height: 27px;
  letter-spacing: -0.487911px;
  color: #4A4A4A;
}
.flex-wrap {
  flex-wrap: wrap;
}
</style>



// WEBPACK FOOTER //
// src/views/data-connectivity/jDataConnectivityList.vue